import { UPLOAD_ENTITY_TYPES } from "constants/documentUploads";
import { NEW_DOCUMENT_ID } from "slices/writing/constants";
import isNullish from "utils/isNullish";
import toStorageEntityType from "utils/toStorageEntityType";

export const WriterEditorView = Object.freeze({
  WRITING: "WRITING",
  RESEARCH: "RESEARCH",
  PROPOSAL_WRITING: "PROPOSAL_WRITING",
});

const EDITOR_VIEW_BY_ENTITY_TYPE = {
  [UPLOAD_ENTITY_TYPES.PROPOSAL]: WriterEditorView.WRITING,
  [UPLOAD_ENTITY_TYPES.CONTRACT]: WriterEditorView.WRITING,
  [UPLOAD_ENTITY_TYPES.MISC_ANALYSIS_RESEARCH]: WriterEditorView.WRITING,
  [UPLOAD_ENTITY_TYPES.OPPORTUNITY]: WriterEditorView.RESEARCH,
  [UPLOAD_ENTITY_TYPES.MISC_ANALYSIS_PROPOSAL_WRITING]:
    WriterEditorView.PROPOSAL_WRITING,
};

export const editorViewFor = (entityType) =>
  EDITOR_VIEW_BY_ENTITY_TYPE[entityType] ?? null;

export const writerSubjectFor = ({ entityType, originId, documentId }) => {
  const editorView = editorViewFor(entityType);
  if (!editorView || isNullish(originId) || !documentId) {
    return null;
  }
  return {
    ownerType: toStorageEntityType(entityType),
    ownerId: Number(originId),
    documentId: String(documentId),
    editorView,
  };
};

export const isUnsavedDocument = (subject) =>
  subject?.documentId === NEW_DOCUMENT_ID;

export const isSameSubject = (a, b) =>
  Boolean(a && b) &&
  a.ownerType === b.ownerType &&
  a.ownerId === b.ownerId &&
  a.documentId === b.documentId &&
  a.editorView === b.editorView;

export const isSameOwner = (a, b) =>
  Boolean(a && b) &&
  a.ownerType === b.ownerType &&
  a.ownerId === b.ownerId &&
  a.editorView === b.editorView;

export const isFirstSaveOf = (pendingFirstSave, subject) =>
  Boolean(pendingFirstSave) &&
  isSameOwner(pendingFirstSave.from, subject) &&
  pendingFirstSave.documentId === subject?.documentId;

export const WRITER_SURFACE = "WRITER";

export const writerSubjectOfRow = (row) => {
  if (row?.surface !== WRITER_SURFACE || !row.pageParams) {
    return null;
  }
  const { ownerType, ownerId, documentId, editorView } = row.pageParams;
  if (!ownerType || isNullish(ownerId) || !documentId || !editorView) {
    return null;
  }
  return {
    ownerType,
    ownerId: Number(ownerId),
    documentId: String(documentId),
    editorView,
  };
};
